export const cardData = [
    {
      id: 111,
      title: "1. I feel down hearted and blue.",
      options: [
        { id: 1, label: "a) None or Little of the time.", weightage: 1 },
        { id: 2, label: "b) Some of the time", weightage: 2 },
        { id: 3, label: "c) Good part of the time.", weightage: 3 },
        { id: 4, label: "d) Most or all the time.", weightage: 4 },
      ],
    },
  
    {
      id: 112,
      title: "2. Morning is when i feel the best.",
      options: [
        { id: 5, label: "a) None or Little of the time.", weightage: 4 },
        { id: 6, label: "b) Some of the time", weightage: 3 },
        { id: 7, label: "c) Good part of the time.", weightage: 2 },
        { id: 8, label: "d) Most or all the time.", weightage: 1 },
      ],
      correctAnswer: 3,
    },
  
    {
      id: 113,
      title: "3. I have crying spells often.",
      options: [
        { id: 9, label: "a) None or Little of the time.", weightage: 1 },
        { id: 10, label: "b) Some of the time", weightage: 2 },
        { id: 11, label: "c) Good part of the time.", weightage: 3 },
        { id: 12, label: "d) Most or all the time.", weightage: 4 },
      ],
      correctAnswer: 0,
    },
  
    {
      id: 114,
      title: "4. I have trouble sleeping at night.",
      options: [
        { id: 13, label: "a) None or Little of the time.", weightage: 1 },
        { id: 14, label: "b) Some of the time", weightage: 2 },
        { id: 15, label: "c) Good part of the time.", weightage: 3 },
        { id: 16, label: "d) Most or all the time.", weightage: 4 },
      ],
      correctAnswer: 2,
    },
  
    {
      id: 115,
      title: "5. I eat as much as I used to.",
      options: [
        { id: 17, label: "a) None or Little of the time.", weightage: 4 },
        { id: 18, label: "b) Some of the time", weightage: 3 },
        { id: 19, label: "c) Good part of the time.", weightage: 2 },
        { id: 20, label: "d) Most or all the time.", weightage: 1 },
      ],
      correctAnswer: 1,
    },
  
    {
      id: 116,
      title: "6. I still enjoy sex.",
      options: [
        { id: 21, label: "a) None or Little of the time.", weightage: 4 },
        { id: 22, label: "b) Some of the time", weightage: 3 },
        { id: 23, label: "c) Good part of the time.", weightage: 2 },
        { id: 24, label: "d) Most or all the time.", weightage: 1 },
      ],
      correctAnswer: 1,
    },
  
    {
      id: 117,
      title: "7. I noticed that I am loosing weight.",
      options: [
        { id: 25, label: "a) None or Little of the time.", weightage: 1 },
        { id: 26, label: "b) Some of the time", weightage: 2 },
        { id: 27, label: "c) Good part of the time.", weightage: 3 },
        { id: 28, label: "d) Most or all the time.", weightage: 4 },
      ],
      correctAnswer: 2,
    },
  
    {
      id: 118,
      title: "8. I have trouble with constipation.",
      options: [
        { id: 29, label: "a) None or Little of the time.", weightage: 1 },
        { id: 30, label: "b) Some of the time", weightage: 2 },
        { id: 31, label: "c) Good part of the time.", weightage: 3 },
        { id: 32, label: "d) Most or all the time.", weightage: 4 },
      ],
      correctAnswer: 2,
    },
  
    {
      id: 119,
      title: "9. My heart beats faster than usual.",
      options: [
        { id: 33, label: "a) None or Little of the time.", weightage: 4 },
        { id: 34, label: "b) Some of the time", weightage: 3 },
        { id: 35, label: "c) Good part of the time.", weightage: 2 },
        { id: 36, label: "d) Most or all the time.", weightage: 1 },
      ],
      correctAnswer: 3,
    },
  
    {
      id: 120,
      title: "10. I get tired for no reason.",
      options: [
        { id: 37, label: "a) None or Little of the time.", weightage: 1 },
        { id: 38, label: "b) Some of the time", weightage: 2 },
        { id: 39, label: "c) Good part of the time.", weightage: 3 },
        { id: 40, label: "d) Most or all the time.", weightage: 4 },
      ],
      correctAnswer: 1,
    },
  
    {
      id: 121,
      title: "11. My mind is as clear as it used to be.",
      options: [
        { id: 41, label: "a) None or Little of the time.", weightage: 4 },
        { id: 42, label: "b) Some of the time", weightage: 3 },
        { id: 43, label: "c) Good part of the time.", weightage: 2 },
        { id: 44, label: "d) Most or all the time.", weightage: 1 },
      ],
      correctAnswer: 0,
    },
  
    {
      id: 122,
      title: "12. I find it easy to do the things I used to do.",
      options: [
        { id: 45, label: "a) None or Little of the time.", weightage: 4 },
        { id: 46, label: "b) Some of the time", weightage: 3 },
        { id: 47, label: "c) Good part of the time.", weightage: 2 },
        { id: 48, label: "d) Most or all the time.", weightage: 1 },
      ],
      correctAnswer: 3,
    },
  
    {
      id: 123,
      title: "13. I am restless and can't keep still.",
      options: [
        { id: 49, label: "a) None or Little of the time.", weightage: 4 },
        { id: 50, label: "b) Some of the time", weightage: 3 },
        { id: 51, label: "c) Good part of the time.", weightage: 2 },
        { id: 52, label: "d) Most or all the time.", weightage: 1 },
      ],
      correctAnswer: 1,
    },
  
    {
      id: 124,
      title: "14. I feel hopeful about the future.",
      options: [
        { id: 53, label: "a) None or Little of the time.", weightage: 4 },
        { id: 54, label: "b) Some of the time", weightage: 3 },
        { id: 55, label: "c) Good part of the time.", weightage: 2 },
        { id: 56, label: "d) Most or all the time.", weightage: 1 },
      ],
      correctAnswer: 1,
    },
  
    {
      id: 125,
      title: "15. I am more irritable than usual.",
      options: [
        { id: 57, label: "a) None or Little of the time.", weightage: 1 },
        { id: 58, label: "b) Some of the time", weightage: 2 },
        { id: 59, label: "c) Good part of the time.", weightage: 3 },
        { id: 60, label: "d) Most or all the time.", weightage: 4 },
      ],
      correctAnswer: 3,
    },
  
    {
      id: 126,
      title: "16. I find it easy to make decisions.",
      options: [
        { id: 61, label: "a) None or Little of the time.", weightage: 4 },
        { id: 62, label: "b) Some of the time", weightage: 3 },
        { id: 63, label: "c) Good part of the time.", weightage: 2 },
        { id: 64, label: "d) Most or all the time.", weightage: 1 },
      ],
      correctAnswer: 1,
    },
  
    {
      id: 127,
      title: "17. I feel that I am useful and needed.",
      options: [
        { id: 65, label: "a) None or Little of the time.", weightage: 4 },
        { id: 66, label: "b) Some of the time", weightage: 3 },
        { id: 67, label: "c) Good part of the time.", weightage: 2 },
        { id: 68, label: "d) Most or all the time.", weightage: 1 },
      ],
      correctAnswer: 0,
    },
  
    {
      id: 128,
      title: "18. My life is pretty full.",
      options: [
        { id: 69, label: "a) None or Little of the time.", weightage: 4 },
        { id: 70, label: "b) Some of the time", weightage: 3 },
        { id: 71, label: "c) Good part of the time.", weightage: 2 },
        { id: 72, label: "d) Most or all the time.", weightage: 1 },
      ],
      correctAnswer: 3,
    },
  
    {
      id: 129,
      title: "19. I feel that others would be better off if I were dead.",
      options: [
        { id: 73, label: "a) None or Little of the time.", weightage: 1 },
        { id: 74, label: "b) Some of the time", weightage: 2 },
        { id: 75, label: "c) Good part of the time.", weightage: 3 },
        { id: 76, label: "d) Most or all the time.", weightage: 4 },
      ],
      correctAnswer: 1,
    },
  
    {
      id: 130,
      title: "20. I still enjoy the things I used to.",
      options: [
        { id: 77, label: "a) None or Little of the time.", weightage: 4 },
        { id: 78, label: "b) Some of the time", weightage: 3 },
        { id: 79, label: "c) Good part of the time.", weightage: 2 },
        { id: 80, label: "d) Most or all the time.", weightage: 1 },
      ],
      correctAnswer: 3,
    },
  ];